import React from 'react';
import './styles.css';
import { Link } from 'react-router-dom';

const ButtonDownload = ({ text, link }) => {
  if (!link) {
    link = '/downloads';
  }
  return (
    <Link to={link}>
      <button className="button-download bg-gray-950 hover:shadow-violet-900 shadow-violet-950 shadow-lg transition text-lg sm:text-xl lg:text-2xl">
        <span></span>
        {text}
      </button>
    </Link>
  );
};

export default ButtonDownload;
